import * as React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';

import { Grid } from '@material-ui/core';

import { MarketShareBookstoreCategoryBisacShare } from './bisacShare/MarketShareBookstoreCategoryBisacShare';
import { MarketShareBookstoreCategoryBisacShareAnalytical } from './bisacShareAnalytical/MarketShareBookstoreCategoryBisacShareAnalytical';
import { MarketShareBookstoreCategoryMarketCategoryShare } from './marketCategoryShare/MarketShareBookstoreCategoryMarketCategoryShare';
import { MarketShareBookstoreCategoryEvolutionCategoryShare } from './evolutionCategoryShare/MarketShareBookstoreCategoryEvolutionCategoryShare';
import { MarketShareBookstoreCategoryProductVolume } from './productVolumeByCategory/MarketShareBookstoreCategoryProductVolume';
import { QUERY_FILTER_MARKET_BOOKSTORE, QueryFilter } from 'src/component/shared';
import { MarketShareBookstoreCategoryPNShare } from './categoryPublishNewsShare/MarketShareBookstoreCategoryPNShare';

const GQL_SALES_BY_THEME = gql`
query marketCategoryBookstoreSalesByTheme($customFilter:  MarketShareCustomFilter) {
    marketCategoryBookstoreSalesByTheme(marketShareCustomFilter: $customFilter) {
        desc,
        
        groupSalesVolume,
        marketSalesVolume,
        storeSalesVolume,

        groupSalesBilling,
        marketSalesBilling,
        storeSalesBilling
    }
}`;

const GQL_VOLUME_PRD_BY_CATEGORY = gql`
query marketCategoryBookstoreQtdProdsByCategory($customFilter:  MarketShareCustomFilter) {
    marketCategoryBookstoreQtdProdsByCategory(marketShareCustomFilter: $customFilter) {
        category,
        qtd_market,
        my_qtd
    }
}`;


// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryProps {
    categoryMenuValue: number;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryState {
    customFilter: {
        isChart: boolean
    },
}

export class MarketShareBookstoreCategory extends React.Component<IMarketShareBookstoreCategoryProps, IMarketShareBookstoreCategoryState> {

    constructor(props: IMarketShareBookstoreCategoryProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
        }
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };

        return (
            <Grid container={true} spacing={16} className="publisher-sale-panel panel-grid">
                {this.props.categoryMenuValue === 1 && <Grid item={true} xs={12} md={12}>
                        <Query query={QUERY_FILTER_MARKET_BOOKSTORE} notifyOnNetworkStatusChange={true} >
                        {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                            return (
                                <div>
                                
                                    <Query query={GQL_SALES_BY_THEME} variables={QueryFilter.getFilterMarketBookstore(clientC, jsonFilter, [], false)} >
                                    {({ loading, error, data, client}) => {
                                        if(data && data.marketCategoryBookstoreSalesByTheme && data.marketCategoryBookstoreSalesByTheme.length > 0) {
                                            data.marketCategoryBookstoreSalesByTheme = data.marketCategoryBookstoreSalesByTheme.sort( (obj1:any, obj2:any) => {
                                                return obj2.you_sales - obj1.you_sales;
                                            });
                                        }
                                        return (
                                            <Grid container={true} spacing={16} className="publisher-sale-panel panel-grid">
                                                <MarketShareBookstoreCategoryBisacShare data={data} loading={loading} type='VOLUME' />

                                                <MarketShareBookstoreCategoryBisacShareAnalytical data={data} loading={loading} type='VOLUME' />

                                                <MarketShareBookstoreCategoryBisacShare data={data} loading={loading} type='FATURAMENTO' />

                                                <MarketShareBookstoreCategoryBisacShareAnalytical data={data} loading={loading} type='FATURAMENTO' />
                                                
                                            </Grid>
                                        )
                                    }}
                                    </Query>
                                    <MarketShareBookstoreCategoryPNShare />
                                </div>
                            );
                        }}
                        </Query>
                    </Grid>}

                    {this.props.categoryMenuValue === 0 && <Grid item={true} xs={12} md={12}>
                        <Grid container={true} spacing={16}>
                            <Grid item={true} xs={6} md={6}>
                                <MarketShareBookstoreCategoryMarketCategoryShare />
                            </Grid>

                            <Grid item={true} xs={6} md={6}>
                                <MarketShareBookstoreCategoryEvolutionCategoryShare />
                            </Grid>
                        </Grid>
                    </Grid>}

                    {this.props.categoryMenuValue === 0 && <Grid item={true} xs={12} md={12}>
                        <Query query={GQL_VOLUME_PRD_BY_CATEGORY} notifyOnNetworkStatusChange={true} >
                        {({ loading, error, data, client}) => {
                            return (
                                <Grid container={true} spacing={16} className="publisher-sale-panel panel-grid">
                                    <Grid item={true} xs={6} md={6}>
                                        <MarketShareBookstoreCategoryProductVolume data={data} loading={loading} type={''} />
                                    </Grid>

                                    <Grid item={true} xs={6} md={6}>
                                        <MarketShareBookstoreCategoryProductVolume data={data} loading={loading} type={'market'} />
                                    </Grid>
                                </Grid>
                            );
                        }}
                        </Query>    
                    </Grid>}
            </Grid>
        );
    }

}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/categoryShare/MarketShareBookstoreCategory.tsx